import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
export function AuthRoute(_a) {
    var isAuthenticated = _a.isAuthenticated, _b = _a.redirectTo, redirectTo = _b === void 0 ? '/dashboard' : _b, children = _a.children;
    return isAuthenticated ? children : React.createElement(Navigate, { to: redirectTo, replace: true });
}
AuthRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    redirectTo: PropTypes.string,
    children: PropTypes.node.isRequired,
};
